import { render } from "./ChildList.vue?vue&type=template&id=7179d2b4&lang=pug"
import script from "./ChildList.vue?vue&type=script&lang=js"
export * from "./ChildList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__